<template>
    <div class="change-email-card">
        <h6 class="personal-information-card__title">{{ $t('Contact Information') }}</h6>
        <div v-if="loadingAccount" class="text-center py-5">
            <b-spinner />
        </div>
        <div v-else>
            <div class="mb-2">
                <change-email-form :account="account" :isSocialAccount="isSocialAccount" @emailUpdated="handleUpdate" />
                <div v-if="isSocialAccount" class="change-email__empty-message-container">
                    <p class="change-email__empty-message text-muted">
                        <span class="fas fa-info-circle"></span>
                        {{ $t('Your account was created with Google. To change your email, please create a password for your account.') }}
                    </p>
                </div>
            </div>
            <change-phone-form :account="account" @phoneUpdated="handleUpdate"/> 
        </div>
    </div>
</template>

<script>
import ChangeEmailForm from '@/components/profile/ChangeEmailForm.vue';
import ChangePhoneForm from '@/components/profile/ChangePhoneForm.vue';

export default {
    name: 'ChangeEmailCard',
    components: { ChangeEmailForm, ChangePhoneForm },
    props: {
        account: {
            type: Object,
            required: true,
        },
    },
    emits: ['accountInformationUpdated'],
    data() {
        return {
           loadingAccount: true,
           isSocialAccount: false,
           _account: {},
        };
    },
    mounted() {
        setTimeout(() => {
            this.getAccount();
        }, 1000);
    },
    methods: {
        getAccount() {
            try {
                this.loadingAccount = true;
                this._account = this.account;
                this.isSocialAccount = this._account.account_type === 'social';

            } catch (error) {
                this.showError(error);
            } finally {
                this.loadingAccount = false;
            }
        },
        handleUpdate(account) {
            this.$emit('accountInformationUpdated', account);
        },
    }
};
</script>

<style lang="scss">
.change-email-card {
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    padding: 16px;

    &__title {
        color: $general-black;
        margin-bottom: 16px;
    }

    &__content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
        width: 100%;
    }

    &__button {
        align-items: center;
        background-color: transparent;
        border: 1px solid #12B4BA;
        border-radius: 8px;
        color: #12B4BA;
        display: flex;
        gap: 8px;
        height: 32px;
        padding: 8px 16px;

        &:hover {
            background-color: #12B4BA;
            color: $white;
        }
    }
}
</style>